import React from 'react';
import Icon from '../../../components/AppIcon';

const JobDescription = ({ job }) => {
  return (
    <div className="bg-surface rounded-lg border border-border p-6">
      <h2 className="text-xl font-bold text-text-primary mb-4 flex items-center">
        <Icon name="FileText" size={20} className="text-primary mr-2" />
        Job Description
      </h2>

      <div className="prose prose-gray max-w-none">
        <div className="text-text-secondary leading-relaxed whitespace-pre-line">
          {job?.description}
        </div>

        {job?.benefits && job.benefits.length > 0 && (
          <div className="mt-6">
            <h3 className="text-lg font-semibold text-text-primary mb-3">Benefits & Perks</h3>
            <ul className="space-y-2">
              {job.benefits.map((benefit, index) => (
                <li key={index} className="flex items-start">
                  <Icon name="Check" size={16} className="text-success mr-2 mt-1 flex-shrink-0" />
                  <span className="text-text-secondary">{benefit}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default JobDescription;
